<template>
    <v-card class="d-flex flex-column justify-space-between" width="350" height="110"  style="position: relative">
        <v-skeleton-loader v-if="loading" type="card" style="position: absolute; width: 100%; height: 100%"/>
        <div class="px-3 pt-2 text-start body-1 font-weight-thin ">
            Top Apps
        </div>
        <template v-if="!loading">
            <v-scroll-x-transition>
                <div class="d-flex align-center flex-grow-1">
                    <div class="flex-grow-1 pb-1" v-if="!loading">
                        <template v-if="stats.length">
                            <table style="table-layout: fixed; width: 100%;">
                                <tr v-for="(app, i) in stats">
                                    <td class="text-end">
                                        <div class="caption grey--text text-truncate txt" @click="gotoAppStats(app.key)">
                                            {{app.key}}
                                        </div>
                                    </td>
                                    <td style="width: 40px">
                                        <div class="d-flex justify-center align-center">
                                            <app-icon class="" small :match="app.key"></app-icon>
                                        </div>
                                    </td>
                                    <td>
                                        <div :style="`width: ${series[i]}%`" style="min-width: 8px; height: 4px; border-radius: 4px; background: linear-gradient(to right, var(--v-primary-darken2), var(--v-primary-lighten1))">
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </template>
                        <template v-else>
                            <div class="flex-grow-1 d-flex align-center justify-center grey--text text--darken-3 overline">
                                No data for today
                            </div>
                        </template>
                    </div>
                </div>
            </v-scroll-x-transition>
        </template>
    </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {hourDisplayWithoutUnit} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
import {mapActions} from "vuex";
export default {
    components: {
        AppIcon,
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        ...mapActions(['gotoAppStats']),
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/topApps')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        labels() {return this.stats.map(stat => stat.key)},
        series() {
            const total = this.stats.reduce((val, item) => {
                return val + item.value
            }, 0)
            return this.stats.map(stat => stat.value/total * 100)
        },
    }
}
</script>

<style scoped>

.txt:hover {
    text-decoration: underline;
    color: #fff !important;
    cursor: pointer;
}

</style>